import { FontSize, StrokeWidth } from '../types';
export interface IconProps {
  icon: string;
  size?: FontSize;
  strokeWidth?: StrokeWidth;
}
